import axiosInstance from './axiosInstance';

export function adminSingleMissionValidate(missionId) {
  return axiosInstance.patch(`/admin/missions/${missionId}/validate`);
}

export function singleMissionValidate(missionId) {
  return axiosInstance.patch(`/missions/${missionId}/validate`);
}

export function checks(checkId, payload) {
  return axiosInstance.patch(`/checks/${checkId}`, payload);
}

export default {
  adminSingleMissionValidate,
  singleMissionValidate,
  checks,
};
